export default "__VITE_ASSET__DevXncHK__"